"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Objects = void 0;
/**
 * Utility class responsible for common and tedious tasks involving Javascript objects (instances of classes).
 */
class Objects {
    /**
     * Returns a list of methods for an instance, including the inherited ones.
     * Example:
     *
     * ```javascript
     * class Base {
     *   constructor() {
     *   }
     *   getX() {
     *     return 'x';
     *   }
     * }
     *
     * class A extends Base {
     *   getA() {
     *     return 'a';
     *   }
     * }
     *
     * const a = new A();
     * const methodNames = Objects.getAllMethodNames(a);
     * console.log(methodNames);
     * // [ 'getA', 'getX' ]
     * ```
     *
     * @param anObject
     */
    static getAllMethodNames(anObject) {
        let properties = [];
        do {
            const symbols = Object.getOwnPropertySymbols(anObject);
            const symbolPropertyNames = symbols.map((aSymbol) => aSymbol.toString());
            const propertyNamesCurrent = Object.getOwnPropertyNames(anObject)
                .concat(symbolPropertyNames)
                .sort()
                .filter((propertyName, index, arr) => {
                return (typeof anObject[propertyName] === "function" &&
                    propertyName !== "constructor" &&
                    (index === 0 || propertyName !== arr[index - 1]) &&
                    properties.indexOf(propertyName) === -1);
            });
            properties = properties.concat(propertyNamesCurrent);
            anObject = Object.getPrototypeOf(anObject);
        } while (anObject && Object.getPrototypeOf(anObject));
        return properties;
    }
    static getAllFieldNames(anObject) {
        const allFieldNames = [];
        for (const propertyKey in anObject) {
            if (anObject.hasOwnProperty(propertyKey)) {
                allFieldNames.push(propertyKey);
            }
        }
        return allFieldNames;
    }
}
exports.Objects = Objects;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tYWluL3R5cGVzY3JpcHQvb2JqZWN0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7R0FFRztBQUNILE1BQWEsT0FBTztJQUNsQjs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7T0EwQkc7SUFDSSxNQUFNLENBQUMsaUJBQWlCLENBQUMsUUFBYTtRQUMzQyxJQUFJLFVBQVUsR0FBYSxFQUFFLENBQUM7UUFDOUIsR0FBRztZQUNELE1BQU0sT0FBTyxHQUFHLE1BQU0sQ0FBQyxxQkFBcUIsQ0FBQyxRQUFRLENBQUMsQ0FBQztZQUN2RCxNQUFNLG1CQUFtQixHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxPQUFPLEVBQUUsRUFBRSxDQUFDLE9BQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxDQUFDO1lBRXpFLE1BQU0sb0JBQW9CLEdBQUcsTUFBTSxDQUFDLG1CQUFtQixDQUFDLFFBQVEsQ0FBQztpQkFDOUQsTUFBTSxDQUFDLG1CQUFtQixDQUFDO2lCQUMzQixJQUFJLEVBQUU7aUJBQ04sTUFBTSxDQUFDLENBQUMsWUFBb0IsRUFBRSxLQUFhLEVBQUUsR0FBRyxFQUFFLEVBQUU7Z0JBQ25ELE9BQU8sQ0FDTCxPQUFPLFFBQVEsQ0FBQyxZQUFZLENBQUMsS0FBSyxVQUFVO29CQUM1QyxZQUFZLEtBQUssYUFBYTtvQkFDOUIsQ0FBQyxLQUFLLEtBQUssQ0FBQyxJQUFJLFlBQVksS0FBSyxHQUFHLENBQUMsS0FBSyxHQUFHLENBQUMsQ0FBQyxDQUFDO29CQUNoRCxVQUFVLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUN4QyxDQUFDO1lBQ0osQ0FBQyxDQUFDLENBQUM7WUFFTCxVQUFVLEdBQUcsVUFBVSxDQUFDLE1BQU0sQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO1lBQ3JELFFBQVEsR0FBRyxNQUFNLENBQUMsY0FBYyxDQUFDLFFBQVEsQ0FBQyxDQUFDO1NBQzVDLFFBQVEsUUFBUSxJQUFJLE1BQU0sQ0FBQyxjQUFjLENBQUMsUUFBUSxDQUFDLEVBQUU7UUFDdEQsT0FBTyxVQUFVLENBQUM7SUFDcEIsQ0FBQztJQUVNLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxRQUFhO1FBQzFDLE1BQU0sYUFBYSxHQUFHLEVBQUUsQ0FBQztRQUN6QixLQUFLLE1BQU0sV0FBVyxJQUFJLFFBQVEsRUFBRTtZQUNsQyxJQUFJLFFBQVEsQ0FBQyxjQUFjLENBQUMsV0FBVyxDQUFDLEVBQUU7Z0JBQ3hDLGFBQWEsQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUM7YUFDakM7U0FDRjtRQUNELE9BQU8sYUFBYSxDQUFDO0lBQ3ZCLENBQUM7Q0FDRjtBQTdERCwwQkE2REMifQ==